<template>
  <div class="balance-container">
    <BalanceWithdrawRecharge
      ref="balanceActions"
    />
    <BalanceTransDetails @get-merchant-info="refreshBalance" />
  </div>
</template>

<script>
export default {
  name: 'Data_Balance',
  components: {
    BalanceWithdrawRecharge: () => import('./components/Balance/BalanceWithdrawRecharge.vue'),
    BalanceTransDetails: () => import('./components/Balance/BalanceTransDetails.vue')
  },
  methods: {
    // 充值记录刷新时同步刷新账户余额
    refreshBalance() {
      if (this.$refs.balanceActions) {
        this.$refs.balanceActions.getMerchantInfo()
      }
    }
  }
}
</script>

<style scoped>
.balance-container{
  margin: 40px 57px 50px 32px;
}
</style>
